(ns app.templates.model
  (:require [clojure.set :as set]
            [clojure.string :as str]))

(def percent-placeholder-pattern #"%([A-Za-z0-9_./-]+)%")
(def simple-selmer-placeholder-pattern #"\{\{\s*([A-Za-z0-9_?./-]+)\s*\}\}")
(def selmer-placeholder-pattern #"\{\{\s*([A-Za-z0-9_?-]+)(?:\|[^}]*)?\s*\}\}")
(def selmer-if-pattern #"\{%\s*if\s+(?:not\s+)?([A-Za-z0-9_?-]+)")
(def selmer-for-pattern #"\{%\s*for\s+[A-Za-z0-9_?-]+\s+in\s+([A-Za-z0-9_?-]+)")
(def selmer-for-binding-pattern #"\{%\s*for\s+([A-Za-z0-9_?-]+)\s+in\s+")

(defn placeholders
  [pattern template]
  (->> (re-seq pattern template)
       (map second)))

(defn template-placeholder-names
  "Names of the placeholders the template expects in its context. Variables bound
   by for-loops are not part of the context and are excluded."
  [template]
  (let [loop-bindings (set (placeholders selmer-for-binding-pattern template))]
    (-> (set (concat (placeholders percent-placeholder-pattern template)
                     (placeholders selmer-placeholder-pattern template)
                     (placeholders selmer-if-pattern template)
                     (placeholders selmer-for-pattern template)))
        (set/difference loop-bindings))))

(defn filename-safe-id
  [id]
  (-> (name id)
      (str/replace #"[^A-Za-z0-9._-]" "_")))
